<style lang="less">
.content {
  width: 100%;
  &__image {
    margin-top: 20px;
    text-align: left;
  }
  .el-upload {
    text-align: left;
    width: 20%;
  }
  .el-upload-list__item {
    transition: none;
  }
}
.desc-view {
  width: 100%;
  align-items: flex-start;
}
.el-dialog__wrapper {
  z-index: 99 !important;
}
.v-modal {
  z-index: 9 !important;
}
.desc-content {
  width: 375px;
  height: auto;
  flex-direction: column;
  box-shadow: 0px 0px 10px #aaa;
  overflow: hidden;
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }
  .desc-content-view {
    position: relative;
    display: block;
    height: auto;
    width: auto;
    overflow: hidden;
    .button-view {
      position: absolute;
      height: 20px;
      right: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.7);
      width: auto;
      color: #fff;
      border-radius: 2px;
      padding: 0 5px;
    }
  }
}
.first-form {
  .el-form-item {
    margin: 0 !important;
  }
  .handle-btn-list {
    display: flex;
    margin: 5px 20px 20px 0;
    .handle-btn {
      position: relative;
      border: none;
      color: rgba(24, 120, 255);
      padding: 9px 10px;
      margin: 0 16px 0 0;
      .line {
        position: absolute;
      }
      .line-top {
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background-image: linear-gradient(
          to right,
          rgba(24, 120, 255) 0%,
          rgba(24, 120, 255) 70%,
          transparent 70%
        );
        background-size: 12px 1px;
        background-repeat: repeat-x;
      }
      .line-left {
        top: 0;
        left: 0;
        bottom: 0;
        width: 1px;
        background-image: linear-gradient(
          to bottom,
          rgba(24, 120, 255) 0%,
          rgba(24, 120, 255) 70%,
          transparent 70%
        );
        background-size: 1px 12px;
        background-repeat: repeat-y;
      }
      .line-right {
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        background-image: linear-gradient(
          to bottom,
          rgba(24, 120, 255) 0%,
          rgba(24, 120, 255) 70%,
          transparent 70%
        );
        background-size: 1px 12px;
        background-repeat: repeat-y;
      }
      .line-bottom {
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        background-image: linear-gradient(
          to right,
          rgba(24, 120, 255) 0%,
          rgba(24, 120, 255) 70%,
          transparent 70%
        );
        background-size: 12px 1px;
        background-repeat: repeat-x;
      }
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.custom-box {
  top: -60px;
}
</style>
<template>
  <div>
    <div class="form-container flex flex-col flex-center">
      <el-form class="first-form" style="margin-left: 0 !important">
        <!-- <el-form-item v-if="!disabled">
          <el-select v-model="form.template_id" placeholder="请选择图文模版（非必填）" @change="selectChange">
            <el-option v-for="(item, index) in collection" :key="index" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item> -->
        <div class="handle-btn-list" v-if="!disabled">
          <el-button
            size="mini"
            @click="setTempSelectIndex('html')"
            class="handle-btn"
          >
            <i class="el-icon-plus"></i>
            <span>添加文字</span>
            <span class="line line-top"></span>
            <span class="line line-left"></span>
            <span class="line line-right"></span>
            <span class="line line-bottom"></span>
          </el-button>
          <el-button
            size="mini"
            @click="setTempSelectIndex('image')"
            class="handle-btn"
          >
            <i class="el-icon-plus"></i>
            <span>添加图片</span>
            <span class="line line-top"></span>
            <span class="line line-left"></span>
            <span class="line line-right"></span>
            <span class="line line-bottom"></span>
          </el-button>
          <el-button
            size="mini"
            @click="setTempSelectIndex('video')"
            class="handle-btn"
          >
            <i class="el-icon-plus"></i>
            <span>添加视频</span>
            <span class="line line-top"></span>
            <span class="line line-left"></span>
            <span class="line line-right"></span>
            <span class="line line-bottom"></span>
          </el-button>
        </div>
      </el-form>
    </div>
    <el-dialog
      :title="addContentDialogTitle"
      :visible.sync="showAddContentDialog"
      :show-close="false"
      @before-close="closeContentDialog"
      class="product-dialog"
      width="900px"
      height="600px"
    >
      <tinymce v-if="editorValue.type === 'html'" v-model="editorValue.value" />
      <el-upload
        v-if="editorValue.type == 'image'"
        :action="uploadPath"
        :headers="uploadHeaders"
        list-type="picture-card"
        :auto-upload="true"
        :beforeUpload="beforeImageUpload"
        :data="uploadImageParam"
        :file-list="photoUrls"
        :accept="imageAccept"
        :limit="100"
        :on-success="uploadSuss"
        :on-remove="uploadRemove"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-upload
        v-if="editorValue.type == 'video'"
        :action="uploadPath"
        :headers="uploadHeaders"
        list-type="picture-card"
        :auto-upload="true"
        :beforeUpload="beforeImageUpload"
        :data="uploadVideoParam"
        :accept="videoAccept"
        :limit="100"
        :file-list="photoUrls"
        :on-success="uploadSuss"
        :on-remove="uploadRemove"
      >
        <i class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" src="@/assets/video.jpg" alt="视频文件">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-delete" @click="handleVideoRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddContentDialog = false">取消</el-button>
        <el-button type="primary" @click="addContentDesc">确定</el-button>
      </div>
    </el-dialog>
    <div class="flex flex-col flex-all-center desc-view">
      <div
        v-if="form.desc && form.desc.length"
        class="desc-content flex flex-center"
      >
        <div
          class="desc-content-view flex flex-row"
          v-for="(item, index) in form.desc"
          :key="index"
        >
          <div
            v-if="item.type === 'html'"
            v-html="item.value"
            style="padding: 10px"
          ></div>
          <div
            class="flex flex-row flex-center"
            style="justify-content: center"
            v-if="item.type === 'image'"
            v-for="(image, index) in item.value"
            :key="index"
          >
            <img
              v-if="image.url"
              :src="image.url"
              style="max-width: 375px; height: auto"
            />
          </div>
          <div
            class="flex flex-row flex-center"
            style="justify-content:center;background:#000"
            v-if="item.type === 'video'"
            v-for="(video, index) in item.value"
            :key="index"
          >
            <video v-if="video.url" :src="video.url" controls style="height:375px;height:225px;"></video>
          </div>
          <div class="flex flex-row flex-center button-view" v-if="!disabled">
            <i class="el-icon-edit-outline" @click="editDescItem(item, index)"
              >编辑</i
            >
            <i
              class="el-icon-delete"
              style="margin-left: 10px"
              @click="deleteDescItem(item, index)"
              >删除</i
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import elupload from "@/components/elupload";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("productTemplate");
import formMixin from "@/mixin/form";

export default {
  mixins: [formMixin],
  computed: {
    ...mapGetters(["collection"]), // 映射必要数据
    addContentDialogTitle() {
      let addString = "添加商品介绍";
      if (
        this.editDescIndex !== "" &&
        this.editDescIndex !== null &&
        this.editDescIndex >= 0
      )
        addString = "编辑";
      if (this.editorValue.type == "html") {
        return addString + "文字内容";
      } else if (this.editorValue.type == "image") {
        return addString + "图片";
      } else {
        return addString + "视频";
      }
    },
    photoUrls() {
      if (this.editorValue.value) {
        if (this.editorValue.value.length) {
          return this.editorValue.value;
        }
        return [{ url: this.editorValue.value }];
      } else return [];
    },
  },
  components: {
    elupload,
    Tinymce,
  },

  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      size: {
        width: "150px",
        height: "150px",
      },
      templateValue: "", // 模版数据
      typeTitle: { html: "文字内容", image: "图片", video: "视频" },
      tempSelectOption: [
        { label: "文字内容", value: "html" },
        { label: "图片", value: "image" },
        { label: "视频", value: "video" },
      ], // 批量操作的选项
      tempSelectIndex: "",
      showAddContentDialog: false,
      showAddContentImageDialog: false,
      editDescIndex: "", // 当前在编辑的行数
      editorValue: { type: "html", value: "" },
    };
  },
  async mounted() {
    // 查询所有模版的信息
    await this.$store.dispatch(`productTemplate/allCollection`);
  },
  methods: {
    // 开始编辑
    editDescItem(item, index) {
      this.editorValue.type = item.type;
      if (item.type == "html") {
        this.editorValue.value = item.value;
      } else {
        this.editorValue.value = [...item.value];
      }
      // if () this.editorValue.value = [ ...item.value ]
      this.editDescIndex = index;
      this.showAddContentDialog = true;
    },
    deleteDescItem(item, index) {
      this.form.desc.splice(index, 1);
    },
    closeContentDialog() {},
    addContentDesc() {
      if (!this.editorValue.value) {
        this.$message.error("请先添加内容");
        return;
      }
      if (
        this.editDescIndex !== "" &&
        this.editDescIndex !== null &&
        this.editDescIndex >= 0
      ) {
        this.form.desc[this.editDescIndex] = { ...this.editorValue };
        this.$message.success("编辑商品内容成功");
      } else {
        this.form.desc.push({ ...this.editorValue });
        this.$message.success("添加商品内容成功");
      }
      this.showAddContentDialog = false;
    },
    selectChange(index) {
      let item = this.collection.find((item) => item.id == index);
      this.form.template_id = item ? item.id : undefined;
    },
    uploadRemove(arr, data1, data2) {
      if (arr && arr.url) {
        this.editorValue.value = this.editorValue.value.filter(item => {
          return item.url != arr.url
        })
      }
    },
    uploadSuss(res, data, value) {
      if (!this.editorValue.value) {
        this.editorValue.value = []
      }
      this.editorValue.value.push({ url: res.data.url });
    },
    contentSelectChange() {
      this.editorValue.type = this.tempSelectIndex;
      this.editorValue.value = "";
      this.tempSelectIndex = "";
      this.editDescIndex = "";
      this.showAddContentDialog = true;
    },
    setTempSelectIndex(value) {
      this.tempSelectIndex = value;
      this.contentSelectChange();
    },
  },
};
</script>
